export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        if (this.itemsPerPageMax100Allowed()) {
            this.options = [
                {value: 10, label: 10},
                {value: 50, label: 50},
                {value: 100, label: 100},
            ];
        } else if (this.itemsPerPageMax500Allowed()) {
            this.options = [
                {value: 10, label: 10},
                {value: 50, label: 50},
                {value: 100, label: 100},
                {value: 500, label: 500},
            ];
        } else {
            this.options = [
                {value: 10, label: 10},
                {value: 50, label: 50},
                {value: 100, label: 100},
                {value: 500, label: 500},
                {value: 1000, label: 1000},
                {value: 1000000, label: 'global.filter.all'}
            ];
        }
    }

    itemsPerPageMax100Allowed() {
        return this.$state.current.name == 'company.spadmin.companies' 
    }

    itemsPerPageMax500Allowed() {
        return this.$state.current.name == 'company.user-directories.directory-groups.all-accounts'
            || this.$state.current.name == 'company.user-directories.manage-group.accounts' 
            || this.$state.current.name == 'company.user-directories.manage-group.accounts.add'
    }

    get totalItemCount() {
        return this.stTable.tableState().pagination.totalItemCount;
    }

    get items() {
        return this.stTable.getFilteredCollection();
    }

    get itemsPerPage() {
        var itemsPerPage = (
            +localStorage.getItem(`items-per-page:${this.$state.current.name}`) ||
            +localStorage.getItem('items-per-page') ||
            100
        )
        if (itemsPerPage > 500) {
            return this.itemsPerPageMax500Allowed() ? 500 : itemsPerPage 
        }
        if (itemsPerPage > 100) {
            return this.itemsPerPageMax100Allowed() ? 100 : itemsPerPage 
        }
        return (itemsPerPage < 10) ? 10 : itemsPerPage;
    }

    set itemsPerPage(value) {
        value = value < 10 ? 10 : value;
        this.deselectAllItems();
        if (!this.hasCustomItemsPerPage || !localStorage.getItem('items-per-page')) {
            localStorage.setItem('items-per-page', value);
        }
        if (this.hasCustomItemsPerPage) {
            localStorage.setItem(`items-per-page:${this.$state.current.name}`, value);
        }
    }

    deselectAllItems() {
        this.items.forEach(item => item.isSelected = false);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/smart-table/pagination/sp-pagination.controller.js